import {CSSProperties} from "react";

interface BooleanInputProps {
    value: boolean;
    style?: CSSProperties;
    onChange(value: boolean): void;
}

function BooleanInput(props: BooleanInputProps) {
    return (
        <input type={'checkbox'} checked={props.value} onClick={e => e.stopPropagation()} onChange={() => {
            props.onChange(!props.value);
        }} style={props.style}/>
    )
}

export default BooleanInput;